import * as tslib_1 from "tslib";
import * as React from 'react';
import * as classNames from 'classnames';
import './badge.scss';
import { DefaultIcon } from './DefaultIcon';
import { Wrapper } from './Wrapper';
var Badge = /** @class */ (function (_super) {
    tslib_1.__extends(Badge, _super);
    function Badge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            icon: '',
            failed: false,
        };
        _this.onClick = function () {
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.badge);
            }
        };
        _this.setIconRef = function (element) {
            _this.iconRef = element;
        };
        _this.isWixMediaManagerIcon = function () {
            var url = new URL(_this.props.badge.icon);
            return url.hostname === 'static.wixstatic.com';
        };
        _this.fetchIcon = function () {
            var badge = _this.props.badge;
            if (badge.icon && _this.isWixMediaManagerIcon) {
                fetch(badge.icon)
                    .then(function (res) {
                    _this.setState({ failed: !res.ok, icon: '' });
                    return res.text();
                })
                    .then(function (icon) { return _this.setState({ icon: icon }); });
            }
        };
        _this.renderIcon = function () {
            var _a = _this.props, size = _a.size, layout = _a.layout, badge = _a.badge, hideDefaultIcon = _a.hideDefaultIcon;
            var iconClass = classNames('icon', size, layout);
            if (layout === 'name-only') {
                return null;
            }
            if (badge.icon && !_this.isWixMediaManagerIcon()) {
                return React.createElement("img", { className: iconClass, src: badge.icon });
            }
            if (badge.icon && !_this.state.failed) {
                return React.createElement("div", { ref: _this.setIconRef, className: iconClass, dangerouslySetInnerHTML: { __html: _this.state.icon } });
            }
            if (layout !== 'icon-only') {
                return null;
            }
            if (!hideDefaultIcon) {
                return React.createElement(DefaultIcon, null);
            }
        };
        return _this;
    }
    Badge.prototype.componentDidMount = function () {
        this.fetchIcon();
    };
    Badge.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.badge.icon !== this.props.badge.icon) {
            this.fetchIcon();
        }
        if (!this.iconRef) {
            return;
        }
        var svg = this.iconRef.getElementsByTagName('svg')[0];
        var isSvgAttached = svg && svg.parentNode && svg.parentNode.offsetParent;
        if (isSvgAttached) {
            var bbox = svg.getBBox();
            var viewBox = [bbox.x, bbox.y, bbox.width, bbox.height].join(' ');
            svg.setAttribute('viewBox', viewBox);
            svg.setAttribute('width', bbox.width + "px");
            svg.setAttribute('height', bbox.height + "px");
        }
        if (prevState.icon !== this.state.icon && this.props.onLoadIcon) {
            this.props.onLoadIcon();
        }
    };
    Badge.prototype.render = function () {
        var _a = this.props, size = _a.size, layout = _a.layout, background = _a.background, badge = _a.badge, borderRadius = _a.borderRadius, font = _a.font, onClick = _a.onClick, textStyle = _a.textStyle, truncateTitle = _a.truncateTitle;
        var backgroundClass = background ? '' : 'no-background';
        var cursorClass = onClick ? 'pointer' : '';
        var wrapperClass = classNames('wrapper', size, layout, backgroundClass, cursorClass);
        var showName = layout !== 'icon-only';
        var textClass = classNames('text', truncateTitle && 'truncated');
        return (React.createElement(Wrapper, { badge: badge, layout: layout },
            React.createElement("div", { onClick: this.onClick, className: wrapperClass, style: {
                    backgroundColor: badge.backgroundColor,
                    borderRadius: borderRadius + "px",
                } },
                React.createElement("div", { className: "inner" },
                    this.renderIcon(),
                    showName && (React.createElement("span", { className: textClass, style: tslib_1.__assign({ color: badge.textColor, fontFamily: font }, textStyle) }, badge.title))))));
    };
    return Badge;
}(React.Component));
export { Badge };
//# sourceMappingURL=Badge.js.map